import DialogQualtrics from '@/app/components/UI/Dialogs/DialogQualtrics/DialogQualtrics'
import { ProjectApiSurvey } from '@/app/models/projects-service'
import {
    getSurveyStatus,
    getVisitProjectDetails,
    setProjectDetails,
} from '@/app/redux/actions/activity-execution'
import { layoutActions, ModalsType, User } from '@Techedge/digitalportal-shared'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { LuxButton } from '@lux/wardrobe-lib'
import VisitActionCard from './VisitActionCard/VisitActionCard'
import DialogVisitDownloadSurvey from './DialogVisitDownloadSurvey/DialogVisitDownloadSurvey'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '@/app/redux/reducers/activity-execution'
import { useVisitExport } from '../../../../hooks/useVisitExport'
import { SectionFilter } from '@/app/models/search'
import './VisitExecutionAction.scss'
import NewSurveyTask from '@/app/containers/NewSurveyTask'
export interface VisitExecutionActionProps {
    surveys: ProjectApiSurvey[]
    storeId: string
    projectId: string
    user: User
    surveyStatusUpdateMap: Record<string, any>
    jwt: string
    projectName: string
    projectStatus: string
    surveyId: string
    getSurveyStatus: (surveyId: string, storeId: string, projectId: string) => void
    getVisitProjectDetails: (projectId: string, stores?: string[]) => void
    onOpenCreateSurveyTask: (props: Record<string, string>) => void
    setProjectDetails: () => void
    setLoading: (loading: boolean) => void
    onOpenSurveyTask: (props: Record<string, any>) => void
}

const VisitExecutionAction = ({
    storeId,
    projectId,
    surveys,
    user,
    surveyStatusUpdateMap,
    jwt,
    projectName,
    surveyId,
    projectStatus,
    getSurveyStatus,
    getVisitProjectDetails,
    onOpenCreateSurveyTask,
    setProjectDetails,
    setLoading,
    onOpenSurveyTask,
}: VisitExecutionActionProps) => {
    const componentClass = 'smart-modals-visit-execution-action'

    const [dialogQualtricsVisible, setDialogQualtricsVisible] = useState<boolean>(false)
    const [dialogDownloadVisible, setDialogDownloadVisible] = useState<boolean>(false)
    const [dialogNewSurveyTaskVisible, setDialogNewSurveyTaskVisible] = useState<boolean>(false)
    const [canExecute, setCanExecute] = useState<boolean>(false)
    const [selectedSuveyId, setSelectedSuveyId] = useState<string>('')
    const [selectedSuveyName, setSelectedSuveyName] = useState<string>('')
    // const [selectedSuveyAnswer, setSelectedSuveyAnswer] = useState<any>(null)
    const [selectedSuveyUrl, setSelectedSuveyUrl] = useState<string>('')
    const [updatingStatusMap, setUpdatingStatusMap] = useState<Record<string, any>>({})

    const intl = useIntl()
    const { onDownload } = useVisitExport()

    const onOpenSurvey = (survey: ProjectApiSurvey) => {
        const statusToExecuteSurvey = [
            SectionFilter.new.toString(),
            SectionFilter.inProgress.toString(),
            SectionFilter.overdue.toString(),
        ]
        const canExecuteLocal =
            survey.assignmentUserId.includes(user.user_id) ||
            survey.assignment.includes(user.business_function)
        setCanExecute(canExecuteLocal)
        setSelectedSuveyId(survey.surveyId)
        setSelectedSuveyName(survey.surveyName)
        // setSelectedSuveyAnswer(survey.answer)
        let surveyUrlParams = '?readOnly=true'
        if (!statusToExecuteSurvey.includes(projectStatus))
            surveyUrlParams = `?Q_R=${survey.answer?.surveyResponse?.responseId}&readOnly=true`
        if (statusToExecuteSurvey.includes(projectStatus) && canExecuteLocal)
            surveyUrlParams = `?Q_R=${survey.answer?.surveyResponse?.responseId}&user_id=${user.user_id}&user_role=${user.role}&visit_id=${projectId}&store_id=${storeId}&parentOrigin=${window.location.origin}`
        setSelectedSuveyUrl(survey.surveyUrl + surveyUrlParams)
        setDialogQualtricsVisible(true)
    }
    const onOpenTask = (id: string) => {
        onOpenSurveyTask({ id, storeIds: [storeId], isFromVisit: true })
    }

    const onQualtricsSubmit = () => {
        // if (!selectedSuveyAnswer && canExecute) {
        if (canExecute) {
            const interval = setInterval(() => {
                getSurveyStatus(selectedSuveyId, storeId, projectId)
            }, 1000)
            setUpdatingStatusMap((map) => ({
                ...map,
                [selectedSuveyId]: interval,
            }))
        }
    }
    const getCompletedSurveys = () => {
        return surveys.filter((s) => !!s.answer).length
    }

    const onDownloadHandler = (surveySvtIds: string[]) => {
        onDownload({ projectId, projectName, jwt, surveySvtIds, setLoading })
    }

    const onCreateSurveyTask = (params: Record<string, string>) => {
        setProjectDetails()
        onOpenCreateSurveyTask(params)
        setDialogNewSurveyTaskVisible(true)
    }

    const onCloseCreateSurveyTask = () => {
        setDialogNewSurveyTaskVisible(false)
        getVisitProjectDetails(projectId, [storeId])
    }

    useEffect(() => {
        if (surveyStatusUpdateMap[selectedSuveyId]?.status === SectionFilter.completed) {
            clearInterval(updatingStatusMap[selectedSuveyId])
            getVisitProjectDetails(projectId, [storeId])
        }
    }, [surveyStatusUpdateMap[selectedSuveyId]])

    useEffect(() => {
        return () => {
            Object.values(updatingStatusMap).forEach((i) => clearInterval(i))
        }
    }, [updatingStatusMap])

    useEffect(() => {
        if (!!surveyId && surveys.length > 0) {
            onOpenSurvey(surveys.find((s) => s.surveyId === surveyId))
        }
    }, [surveys])

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__title text-bold`}>
                {intl.formatMessage({
                    id: 'modals.activity.visit.action.title',
                    defaultMessage: 'Surveys to complete',
                })}
            </div>
            <div className={`${componentClass}__description text`}>
                <div>
                    {surveys.length}{' '}
                    {intl.formatMessage({
                        id: 'modals.news_execution.action.action_card.title.surveys',
                        defaultMessage: 'Surveys',
                    })}
                </div>
                <div>
                    {intl.formatMessage({
                        id: 'modals.news_execution.action.action_card.status.completed',
                        defaultMessage: 'Completed',
                    })}
                    : {getCompletedSurveys()}/{surveys.length}
                </div>
            </div>
            {surveys?.map((survey) => (
                <div className={`${componentClass}__card`}>
                    <VisitActionCard
                        key={1}
                        survey={survey}
                        progress={survey.answer ? 100 : 0}
                        showStatusDisclaimer={
                            updatingStatusMap[selectedSuveyId] &&
                            surveyStatusUpdateMap[selectedSuveyId]?.status !==
                                SectionFilter.completed
                        }
                        onOpenSurvey={onOpenSurvey}
                        onOpenTask={onOpenTask}
                    />
                </div>
            ))}
            {projectStatus !== SectionFilter.new && (
                <div className={`${componentClass}__download`}>
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'modals.activity.visit.action.download.survey',
                            defaultMessage: 'Download Survey',
                        })}
                        variant={'outlined'}
                        onClick={() => setDialogDownloadVisible(true)}
                    />
                </div>
            )}
            {dialogDownloadVisible && (
                <DialogVisitDownloadSurvey
                    dialogVisible={dialogDownloadVisible}
                    surveys={surveys}
                    onHide={() => setDialogDownloadVisible(false)}
                    onDownload={onDownloadHandler}
                />
            )}
            <DialogQualtrics
                surveyUrl={selectedSuveyUrl}
                surveyTitle={selectedSuveyName}
                dialogVisible={dialogQualtricsVisible}
                hideDialog={dialogNewSurveyTaskVisible}
                onHide={() => setDialogQualtricsVisible(false)}
                onSubmit={onQualtricsSubmit}
                onCreateSurveyTask={onCreateSurveyTask}
            />
            {dialogNewSurveyTaskVisible && (
                <NewSurveyTask closeNewActivity={onCloseCreateSurveyTask} />
            )}
        </div>
    )
}

const mapStateToProps = (state) => ({
    surveyStatusUpdateMap: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].surveyStatusUpdateMap,
    jwt: state.userReducer.accessToken,
    surveyId: state.layoutReducer.modals.props?.survey_id,
})

const mapDispatchToProps = (dispatch: any) => ({
    onOpenCreateSurveyTask: (props: Record<string, string>) =>
        dispatch(
            layoutActions.setModals({
                // type: ModalsType.NEW_SURVEY_TASK,
                props: { ...props, id: null },
            })
        ),
    onOpenSurveyTask: (props: Record<string, any>) =>
        dispatch(
            layoutActions.setModals({
                type: ModalsType.TASK_EXECUTION,
                props,
            })
        ),
    getSurveyStatus: (surveyId: string, storeId: string, projectId: string) =>
        dispatch(getSurveyStatus(surveyId, storeId, projectId)),
    getVisitProjectDetails: (projectId: string, stores?: string[]) =>
        dispatch(getVisitProjectDetails(projectId, stores)),
    setProjectDetails: () => dispatch(setProjectDetails({})),
    setLoading: (loading: boolean) => dispatch(layoutActions.setModals({ props: { loading } })),
})

export default connect(mapStateToProps, mapDispatchToProps)(VisitExecutionAction)
